import { BasicDataWorkspaceFragment } from "./queries.graphql";
import useBasicData from "./useBasicData";

/**
 * A variant of useBasicData that asserts activeWorkspace is non-null.
 * Use this in contexts where an active workspace is guaranteed to exist.
 * Throws an error if activeWorkspace is null, indicating a programming error.
 */
export const useRequiredActiveWorkspace = (): Omit<
  ReturnType<typeof useBasicData>,
  "activeWorkspace"
> & { activeWorkspace: BasicDataWorkspaceFragment } => {
  const { activeWorkspace, ...rest } = useBasicData();

  if (!activeWorkspace) {
    throw new Error(
      "useRequiredActiveWorkspace must be used within an active workspace context",
    );
  }

  return { activeWorkspace, ...rest };
};
